import type { RecordStepperStore, RecordStepperView } from "~/components/recordStepper/recordStepperTypes";

import { useContext, useSyncExternalStore } from "react";

import { HIDDEN_RECORD_STEPPER_VIEW } from "~/components/recordStepper/createRecordStepperStore";
import RecordStepperContext from "~/components/recordStepper/RecordStepperContext";

const subscribeToNothing = () => () => {};
const readHiddenView = () => HIDDEN_RECORD_STEPPER_VIEW;

const useRecordStepperView = (): { stepper: null | RecordStepperStore; view: RecordStepperView } => {
	const stepper = useContext(RecordStepperContext);
	const view = useSyncExternalStore(stepper?.subscribe ?? subscribeToNothing, stepper?.getView ?? readHiddenView);
	return { stepper, view };
};

export default useRecordStepperView;
